// TODO - refactor into generated enum
export enum Country {
  Afghanistan = 'AF',
  Andorra = 'AD',
  Argentina = 'AR',
  Austria = 'AT',
  Belgium = 'BE',
  Bulgaria = 'BG',
  Brazil = 'BR',
  Canada = 'CA',
  Chile = 'CL',
  Denmark = 'DK',
  Estonia = 'EE',
  France = 'FR',
  FrenchGuiana = 'GF',
  Germany = 'DE',
  Gibraltar = 'GI',
  GreatBritain = 'GB',
  Greece = 'GR',
  Greenland = 'GL',
  Guadeloupe = 'GP',
  Guernsey = 'GG',
  India = 'IN',
  Ireland = 'IE',
  Italy = 'IT',
  Jersey = 'JE',
  Martinique = 'MQ',
  Mayotte = 'YT',
  Mexico = 'MX',
  Morocco = 'MA',
  Netherlands = 'NL',
  Peru = 'PE',
  Portugal = 'PT',
  Reunion = 'RE',
  Romania = 'RO',
  Russia = 'RU',
  Slovenia = 'SI',
  Spain = 'ES',
  Ukraine = 'UA',
  UnitedKingdom = 'UK',
  UnitedStates = 'US',
  Uruguay = 'UY'
}

export enum PlatformMask {
  WINDOWS = 0x00000001,
  MACOS = 0x00000002,
  IOS = 0x00000004,
  ANDROID = 0x00000008,
  WEB = 0x00000010,
  WEBMOBILE = 0x00000080,
  LINUX = 0x00000020
}

export enum MoneyOption {
  Real,
  Play
}

export enum Vertical {
  Global,
  Account,
  Casino,
  Sports = 4
}

export enum EulaType {
  CombinedEulaPrivacy = 'combinedEulaPrivacy',
  Eula = 'eula',
  GameRulesConditions = 'gameRulesConditions',
  GamingAccAgreement = 'gamingAccAgreement',
  IAmEligibleToPlay = 'iAmEligibleToPlay',
  IndianStatesRestrictions = 'indianStatesRestrictions',
  InformationIsComplete = 'informationIsComplete',
  MarketingMailList = 'marketingMailList',
  PlayerIsNot3Party = 'playerIsNot3Party',
  PlayerIsNotPEP = 'playerIsNotPEP',
  Privacy = 'privacy',
  PlayerFundsProtection = 'playerFundsProtection',
  PortugalEligibleToPlay = 'portugalEligibleToPlay'
}

export enum ConsentMethod {
  Email = 'communicationChannelEmail',
  PushNotification = 'communicationChannelPushNotification'
}

export enum ConsentType {
  Poker = 'mailListPoker',
  Casino = 'mailListCasino',
  Sport = 'mailListSports'
}

export enum PostMessage {
  ACCOUNT_RMF = 'c2l://form/realmoney',
  AGE_VERIFICATION_COMPLETED = 'ps_ageverificationcompleted',
  C2L = 'ps_c2l',
  CLOSE_COMPLETED_RMF = 'ps_closedrmf/complete',
  CLOSE_DEPOSIT = 'ps_closedeposit',
  CLOSE_ICE = 'ps_closeice',
  CLOSE_ID_SCAN = 'ps_closeidscan',
  CLOSE_LICENSE_MIGRATION = 'ps_closelicensemigration',
  CLOSE_MINIGAME = 'ps_closeminigame',
  CLOSE_PMCASHIER = 'ps_closepmcashier',
  CLOSE_SRWRDCHESTS = 'ps_srwrdsCloseChests',
  DEPOSIT_OFFER_BONUS_CODE = 'ps_depositofferbonuscode',
  LICENSE_MIGRATION = 'ps_licensemigration',
  LOGOUT = 'ps_logout',
  LOGIN_TIME_LIMITS_NOT_COMPLETED = 'ps_closedrmf/login-time-limits-not-complete',
  NEMID_LOGGEDIN = 'ps_nemid_loggedin',
  OPEN_ACCOUNT = 'ps_openaccount',
  OPEN_BONUSMANAGER = 'ps_openBonusManager',
  OPEN_LUGAS_LIMIT_REGISTRATION = 'ps_openlugaslimitregistration',
  OPEN_VERIFICATION = 'ps_openverification',
  OPEN_DEPOSIT = 'ps_opendeposit',
  OPEN_MINIGAME = 'ps_openminigame',
  OPEN_MITID = 'ps_open_mitid',
  OPEN_PAY_WALL = 'ps_openpaywall',
  REFRESH_ACCOUNT = 'ps_refreshaccount',
  TWITCH = 'twitch',
  VERIFY_EMAIL = 'ps_verifyemail'
}

export enum CRMZone {
  MY_NEWS = 'WSLTARGETED',
  DOWNLOAD_BANNER = 'WSLMOBILEAPPDOWNLOAD',
  STARS_REWARDS_OPT_IN = 'SWREWARDSOPTIN',
  STARS_REWARDS_INFO = 'SWREWARDSINFO',
  SWC_CANCEL_WD_FROM_DEPOSIT = 'SWCCANCELWDFROMDEPOSIT',
  SWC_CASHIER_MAIN = 'SWCCASHIERMAIN',
  SWC_CONVERSION_RESULT = 'SWCCONVERSIONRESULT',
  SWC_CURRENCY_SETTINGS = 'SWCCURSETTINGS',
  SWC_DEPOSIT_MAIN = 'SWCDEPOSITMAIN',
  SWC_DEPOSIT_RESULT = 'SWCDEPOSITRESULT',
  SWC_OVER_CREDIT = 'SWCOVERCREDIT',
  SWC_P2P_RESULT = 'SWCP2PRESULT',
  SWC_TRANSACTION_HISTORY = 'SWCTXNHISTORY',
  SWC_TRANSITION_TO_WC2 = 'SWCTRANSITIONTOWC2',
  SWC_WITHDRAW_RESULT = 'SWCWDRESULT',
  SWC_WELCOME_BONUS = 'SWCWELCOMEBONUS',
  WSL_WELCOME_OFFER_POPUP = 'WSLWELCOMEOFFERPOPUP1',
  WSL_WELCOME_OFFER_ICON = 'WSLWELCOMEOFFERICON'
}

export enum Header {
  Auth = 'x-stars-authenticated',
  Banner = 'x-stars-banner',
  Bot = 'x-stars-bot',
  Brand = 'x-stars-brand',
  Cache = 'x-skip-cache',
  Country = 'x-stars-geo-country',
  Currency = 'x-stars-currency',
  Device = 'x-device',
  Embedded = 'x-stars-embedded',
  Forwarded = 'x-forwarded-for',
  Host = 'x-forwarded-host',
  IspAccountCountry = 'x-isp-account-country',
  IspPromotionsPermitted = 'x-isp-promotions-permitted',
  IspFeatures = 'x-isp-feature-flag',
  OddsFormat = 'x-stars-odds-format',
  Locale = 'x-stars-locale',
  OS = 'x-os-family',
  PowResult = 'pow-result',
  Protocol = 'x-forwarded-proto',
  Region = 'x-stars-region',
  Render = 'x-stars-render',
  RequestId = 'x-request-id',
  Site = 'x-stars-site',
  State = 'x-stars-geo-state',
  TimeZone = 'x-stars-time-zone',
  Uri = 'x-origin-uri',
  FiSiteId = 'x-fi-ps-site-id',
  FiDeviceId = 'x-fi-ps-device-id',
  FiOsId = 'x-fi-ps-os-id',
  FiBrandId = 'x-fi-ps-brand-id',
  FiInstallId = 'x-fi-ps-install-id',
  FiAppTypeId = 'x-fi-ps-app-type-id',
  FiProductId = 'x-fi-ps-product-id',
  FiPlatformId = 'x-fi-ps-platform-id'
}

export enum Source {
  Direct = 'Direct',
  Affiliate = 'Affiliate',
  Adwords = 'Adwords',
  Display = 'Display',
  SEO = 'SEO'
}

export enum FormMethod {
  Post = 'post',
  Get = 'get'
}

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark'
}

export enum UILayout {
  Table = 'table',
  Grid = 'grid'
}

export enum DocumentType {
  Passport,
  DrivingLicense,
  NationalIDCard
}

export enum LimitType {
  POKER = 5,
  POKER_TIME = 31,
  SPORT = 15
}

export enum SuspendAccountCode {
  ExclusionList = '1',
  Blacklisted = '4',
  Suspended = '24',
  PlayerNotAuthorized = '1233'
}

export enum NetDepositLimitGroup {
  Unknown = 0,
  YoungUser = 1,
  NewUser = 2,
  ExistingUser = 3
}

export enum GADimension {
  AffiliateCode = 'dimension1',
  License = 'dimension3',
  LangId = 'dimension5',
  ResolverTag = 'dimension10',
  GClientID = 'dimension11',
  WebClientID = 'dimension12',
  ACID = 'dimension13',
  WebIDHit = 'dimension14',
  TimeStamp = 'dimension15',
  SizmekID = 'dimension16',
  MaxymiserID = 'dimension17',
  SignalID = 'dimension18',
  WebIDSession = 'dimension20',
  PromoIA = 'dimension21',
  MSClickID = 'dimension22',
  MachineID = 'dimension25',
  ClientID = 'dimension26',
  SizmekClickID = 'dimension27',
  BrandCode = 'dimension30',
  ApplicationType = 'dimension32',
  DataSource = 'dimension33',
  ApplicationVersion = 'dimension36',
  StarsCardPhysicalCardHolder = 'dimension46',
  UIElementId = 'dimension47',
  UIElementTypeId = 'dimension48',
  UIElementName = 'dimension49',
  UIElementTitle = 'dimension50',
  UIElementLocation = 'dimension51',
  UIElementPosition = 'dimension52',
  UIElementExtendedAttributes = 'dimension53',
  VisitId = 'dimension55',
  IsRMplayer = 'dimension62',
  IsPMplayer = 'dimension63',
  BrandName = 'dimension64',
  SiteName = 'dimension65',
  HostApplicationType = 'dimension66',
  HostApplicationVersion = 'dimension67',
  FacebookClickId = 'dimension73',
  FacebookBrowserId = 'dimension74',
  MoneyType = 'dimension75',
  PageOriginPath = 'dimension76',
  GameName = 'dimension80',
  GameCode = 'dimension81',
  GameTags = 'dimension82',
  GamePlayMode = 'dimension83',
  GameJackpot = 'dimension84',
  GamesInView = 'dimension85',
  GamesTotal = 'dimension86',
  GameVariantID = 'dimension87',
  TabName = 'dimension90',
  WidgetName = 'dimension91',
  LaunchSource = 'dimension92',
  IsFavourite = 'dimension96',
  ActiveTab = 'dimension97',
  ModalContent = 'dimension98',
  WidgetContents = 'dimension99',
  Profit = 'dimension100',
  CampaignID = 'dimension101',
  InputValue = 'dimension102',
  RadioButtonActive = 'dimension103',
  HSPOrFeatureFlags = 'dimension104',
  PlayerCurrency = 'dimension105',
  Amount = 'dimension106',
  ErrorsTracked = 'dimension107',
  GameTicketNumber = 'dimension108',
  TabPosition = 'dimension109',
  AMSPromoCode = 'dimension114',
  TicketID = 'dimension116',
  DepositStatus = 'dimension118',
  DepositRedirectStatus = 'dimension119',
  DepositGateway = 'dimension120',
  TransactionType = 'dimension121',
  TransactionStatus = 'dimension122',
  Conversion = 'dimension123',
  TransactionDate = 'dimension124',
  TransactionId = 'dimension125',
  PaysystemName = 'dimension126',
  PreviouslyActioned = 'dimension127'
}

export enum CustomIDScanErrors {
  CAMERA_INIT = 'EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE'
}

export enum BelgianRegulatorError {
  OLD_SERVICE = 1,
  DEFAULT_ERROR,
  PLAYER_EXISTS,
  BANNED,
  BANNED_ON_VALIDATION,
  MAJOR_ERROR,
  COMM_ERROR,
  ACC_RESTRICTED
}

export enum CasinoOperand {
  EQ = 1,
  NEQ = 2,
  LS = 4,
  LEQ = 8,
  GR = 16,
  GEQ = 32,
  IN = 64,
  NOT_IN = 128,
  LIKE = 256,
  NOT_LIKE = 512,
  BITAND = 1024,
  BETWEEN = 2048
}

export enum CasinoJoinOperand {
  AND = 0,
  OR = 1,
  AND_NOT = 2
}

export enum CasinoTargetingMode {
  All = 'All',
  Include = 'Include',
  Exclude = 'Exclude'
}

export enum CasinoTargetingPlatform {
  All = 'All',
  Mobile = 'Mobile',
  Desktop = 'Desktop'
}

export enum Category {
  Core = 'Core',
  Marketing = 'Marketing',
  Casino = 'Casino',
  Sports = 'Sports',
  Poker = 'Poker'
}

export enum NotificationServiceTopic {
  PAM_SG = 'pam-safer-gaming',
  PAM_AUTH = 'pam-authentication',
  RCS = 'rcs',
  PSN_PARTNER = 'psn-partner-notifications'
}

export enum NotificationServiceType {
  DepositLimitsReminder = 'UK_REMINDER_REVIEW_DEPOSIT_LIMITS',
  SpendBudget = 'UK_SPEND_BUDGET_APPLIED',
  UKAccountInfoReminder = 'UK_REMINDER_ACCOUNT_INFO',
  IdpInactivityWarning = 'IDP_INACTIVITY_WARNING',
  IdpInactivityLogout = 'IDP_INACTIVITY_LOGOUT',
  MsgLobbyETCCLINotifyAccountReinstate = 'MSG_LOBBYETC_CLI_NOTIFY_ACCOUNT_REINSTATE',
  MsgLobbyETCCLINotifyCVLState = 'MSG_LOBBYETC_CLI_NOTIFY_CVL_STATE',
  MsgLobbyETCCLINotifyGeoIPResult = 'MSG_LOBBYETC_CLI_NOTIF_GEOIP_RESULT',
  MsgLobbyETCCLINotifyLugasLongSession = 'MSG_LOBBYETC_CLI_NOTIFY_LUGAS_LONG_SESSION',
  MsgLobbyETCCLINotifyMPCIssued = 'MSG_LOBBYETC_CLI_NOTIFY_MPC_ISSUED',
  MsgLobbyETCCLINotifyPredictorTickets = 'MSG_LOBBYETC_CLI_NOTIFY_PREDICTOR_TICKETS',
  MsgLobbyETCCLISESessionNotif = 'MSG_LOBBYETC_CLI_SE_SESSION_NOTIF',
  MsgLobbyETCCLIUnsolicitedNotification = 'MSG_LOBBYETC_CLI_UNSOLICITED_NOTIFICATION',
  MsgLobbyETCGeocomplyLocate = 'MSG_LOBBYETC_GEOCOMPLY_LOCATE',
  MsgLobbyETCRAMROSessionDurationNotification = 'MSG_LOBBYETC_RAM_RO_SESSION_DURATION_NOTIFICATION',
  MsgLobbyETCSEChangeUserNotification = 'MSG_LOBBYETC_SE_CHANGE_USER_NOTIFICATION',
  MsgLobbyETCUCLICNotifyPlayHistoryReport = 'MSG_LOBBYETC_U_CLI_NOTIFY_PLAY_HISTORY_REPORT',
  MsgLobbyETCUDisplayValueProposition = 'MSG_LOBBYETC_U_DISPLAY_VALUE_PROPOSITION',
  MsgLobbyETCTOClientInfoNotification = 'MSG_LOBBYETC_TO_CLIENT_INFO_NOTIFICATION',
  MsgLobbyAdminInfo = 'MSG_LOBBY_ADMIN_INFO',
  MsgLobbyCLIForceReauth = 'MSG_LOBBY_CLI_FORCE_REAUTH',
  MsgCLILoginEvent = 'MSG_CLI_LOGIN_EVENT',
  MsgCLIFRLoginEvent = 'MSG_CLI_FR_LOGIN_EVENT',
  MsgCLIITLoginEvent = 'MSG_CLI_IT_LOGIN_EVENT',
  MsgLobbyForceClientLogout = 'MSG_LOBBY_FORCECLIENTLOGOUT',
  MsgLobbyNotification = 'MSG_LOBBY_NOTIFICATION',
  MsgLobbyPlayerBlacklistedNotify = 'MSG_LOBBY_PLAYER_BLACKLISTED_NOTIFY',
  MsgLobbyNotificationPlayingtimeUpdate = 'MSG_LOBBY_NOTIFICATION_PLAYINGTIME_UPDATE',
  MsgLobbyCLIPwdChangeReminder = 'MSG_LOBBY_CLI_PWD_CHANGE_REMINDER',
  WTSUTokenExpireWarning = 'WTS_U_TOKEN_EXPIRE_WARNING',
  WTSUTokenInvalid = 'WTS_U_TOKEN_INVALID',
  ParterNotification = 'PARTNER_NOTIFICATION'
}
